import { render, staticRenderFns } from "./commonFun.vue?vue&type=template&id=3daa4e50&scoped=true&"
import script from "./commonFun.vue?vue&type=script&lang=js&"
export * from "./commonFun.vue?vue&type=script&lang=js&"
import style0 from "./commonFun.vue?vue&type=style&index=0&id=3daa4e50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daa4e50",
  null
  
)

export default component.exports